import { ECPDActionTypes, TCPDActions } from '../../actions/cpd';
import { ECpdDraftStatus, ICPDState } from '../../types/cpd/cpd';

const defaultState: ICPDState = {
  isCpdAvailable: false,
  cpdDraftStatus: ECpdDraftStatus.init,
};

export const cpdReducer = (state: ICPDState = defaultState, action: TCPDActions): ICPDState => {
  switch (action.type) {
    case ECPDActionTypes.setAvailableCpd: {
      return {
        ...state,
        isCpdAvailable: action.payload,
      };
    }

    case ECPDActionTypes.setCpdDraftId: {
      return {
        ...state,
        cpdDraftId: action.payload,
      };
    }

    case ECPDActionTypes.setCpdDraftStatus: {
      return {
        ...state,
        cpdDraftStatus: action.payload,
      };
    }

    default:
      return state;
  }
};
